import React, { useEffect, useState, useRef } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button, Modal, ModalBody, Label } from "reactstrap"
// import "./datatables.scss";
// import '../Icons/IconFontawesome';
import { AvField, AvForm, AvRadio, AvRadioGroup } from "availity-reactstrap-validation";
import { toast } from 'react-toastify';
import Utils from '../Utility';
import { post, get, put, upload, download } from "../../helpers/api_helper";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { saveAs } from 'file-saver';
// import './Card.scss';

const Table = (props) => {
    const { user, role, currentUser, path, setIsAddForm, getData, currentData, setCurrentData, file, setFile } = props;
    const [columns, setColumns] = useState([]);
    const [data, setData] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    // const [currentData, setCurrentData] = useState(null);
    // const [isAddForm, setIsAddForm] = useState(false);
    // const [file, setFile] = useState(null);
    const [imageChanged, setImageChanged] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const imageInput = useRef();
    const cropper = useRef();

    const urltoFile = (url, filename, mimeType) => {
        return (fetch(url)
            .then(function (res) { return res.arrayBuffer(); })
            .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
        );
    }

    // const handleValidSubmit = async (e, values, type) => {
    //     // console.log('values', values, file);
    //     setLoading(true);
    //     if (currentModalData) {
    //         if (imageChanged) {
    //             console.log('updating state changed', typeof file);
    //             const fileData = cropper?.current?.cropper?.getCroppedCanvas().toDataURL();
    //             urltoFile(fileData, new Date().getTime() + '.png', 'image/png')
    //                 .then(async (obj) => {
    //                     console.log('values', obj);
    //                     const image = await resizeFile(obj);
    //                     const form = new FormData();
    //                     form.append("image", image);
    //                     upload("/testimonial/image_upload", form)
    //                         .then(res => {
    //                             console.log('response from image upload', res);
    //                             if (res?.statusCode == 200) {
    //                                 const body = {
    //                                     ...values,
    //                                     testiId: currentModalData?._id,
    //                                     image: res?.data,
    //                                     token: user?.token
    //                                 }
    //                                 put("/testimonial/list", body)
    //                                     .then(json => {
    //                                         console.log('response from add state', json);
    //                                         setLoading(false);
    //                                         if (json.statusCode == 200) {
    //                                             toast.success(json?.message);
    //                                             getMetas();
    //                                             setFile(null);
    //                                             setIsAddForm(false);
    //                                             setCurrentModalData(null);
    //                                         } else {
    //                                             toast.error(json?.error);
    //                                         }
    //                                     })
    //                                     .catch(error => {
    //                                         setLoading(false);
    //                                         console.log('error while uploading image', error);
    //                                         toast.error(error);
    //                                     })
    //                             } else {
    //                                 setLoading(false);
    //                                 toast.error(res?.error);
    //                             }
    //                         })
    //                         .catch(error => {
    //                             setLoading(false);
    //                             console.log('error while uploading image', error);
    //                             toast.error(error);
    //                         });
    //                 });
    //         } else {
    //             const body = {
    //                 ...values,
    //                 giftId: currentModalData?._id,
    //                 token: user?.token
    //             }
    //             put("/testimonial", body)
    //                 .then(json => {
    //                     console.log('response from add state', json);
    //                     setLoading(false);
    //                     if (json.statusCode == 200) {
    //                         toast.success(json?.message);
    //                         getMetas();
    //                         setFile(null);
    //                         setIsAddForm(false);
    //                         setCurrentModalData(null);
    //                     } else {
    //                         toast.error(json?.error);
    //                     }
    //                 })
    //                 .catch(error => {
    //                     setLoading(false);
    //                     console.log('error while uploading image', error);
    //                     toast.error(error);
    //                 });
    //         }
    //     } else {
    //         const fileData = cropper?.current?.cropper?.getCroppedCanvas().toDataURL();
    //         urltoFile(fileData, new Date().getTime() + '.png', 'image/png')
    //             .then(async (obj) => {
    //                 console.log('values', obj);
    //                 const image = await resizeFile(obj);
    //                 const form = new FormData();
    //                 form.append("image", image);
    //                 upload("/testimonial/image_upload", form)
    //                     .then(res => {
    //                         console.log('response from image upload', res);
    //                         if (res?.statusCode == 200) {
    //                             const body = {
    //                                 ...values,
    //                                 image: res?.data,
    //                                 token: user?.token
    //                             }
    //                             post("/testimonial/list", body)
    //                                 .then(json => {
    //                                     console.log('response from add state', json);
    //                                     setLoading(false);
    //                                     if (json.statusCode == 200) {
    //                                         toast.success(json?.message);
    //                                         getMetas();
    //                                         setFile(null);
    //                                         setIsAddForm(false);
    //                                     } else {
    //                                         toast.error(json?.error);
    //                                     }
    //                                 })
    //                                 .catch(error => {
    //                                     setLoading(false);
    //                                     console.log('error while uploading image', error);
    //                                     toast.error(error);
    //                                 })
    //                         } else {
    //                             setLoading(false);
    //                             toast.error(res?.error);
    //                         }
    //                     })
    //                     .catch(error => {
    //                         setLoading(false);
    //                         console.log('error while uploading image', error);
    //                         toast.error(error);
    //                     })
    //             });
    //     }
    // }

    const handleValidSubmit = async (e, v) => {
        if (!loading) {
            setLoading(true);
            let body = {
                ...v,
                token: user?.token
            }
            console.log("file to check", file);
            // if (!file) {
            //     toast.error("Please select a Testimonials Image!");
            //     return;
            // }
            if (file?.substring(0, 4) == 'blob') {
                const obj = await urltoFile(file, new Date().getTime() + '.png', 'image/png');
                const form = new FormData();
                form.append("image", obj);
                const uploadRes = await upload("/location/image_upload", form);
                if (uploadRes?.statusCode == 200)
                    body = { ...body, image: uploadRes?.data };
            }

            if (currentData?._id) {
                body = { ...body, locationId: currentData?._id }
                put("/location", body)
                    .then(res => {
                        setLoading(false);
                        if (res?.statusCode == 200) {
                            setIsAddForm(false);
                            toast.success(res?.message)
                            getData()
                        } else
                            toast.error("" + res?.error);
                    })
                    .catch(err => {
                        setLoading(false);
                        console.error("error while updating data", err);
                        toast.error("Something Went Wrong!");
                    })
            } else {
                post("/location", body)
                    .then(res => {
                        setLoading(false);
                        if (res?.statusCode == 200) {
                            toast.success(res?.message);
                            setIsAddForm(false);
                            getData();
                        } else {
                            toast.error(res?.error);
                        }
                    })
                    .catch(err => {
                        setLoading(false);
                        console.error("Error while adding city", err);
                        toast.error("Something Went Wrong!");
                    })
            }
            setFile(null);
        }
    }

    const onChangeFile = (e) => {
        console.log('getting event on input img', e.target.files[0]);
        setFile(URL.createObjectURL(e.target.files[0]));
    }

    function changeImage() {
        setFile(null);
        if (currentData) {
            props.setCurrentData({ ...currentData, image: undefined })
        }
    }

    return (
        <React.Fragment>
            <div className="">
                <Row>
                    {/* Add or Update depart form */}
                    <Card centered={true}>
                        <CardBody className="py-3 px-5 mt-4">
                            <h5 className="text-black font-size-20">{currentData ? `Update Location!` : `Add New Location!`}</h5>
                            <div className="p-2">
                                <AvForm className="form-horizontal" onValidSubmit={handleValidSubmit}>
                                    <Row>
                                        <Col lg={6} md={6}>
                                            <div className="mb-3 mt-2">
                                                {file || currentData?.image ?
                                                    <>
                                                        <CardTitle >Image</CardTitle>
                                                        <div style={{ flexDirection: 'row', position: 'relative', cursor: 'pointer', marginTop: 20 }}>
                                                            {currentData?.image ?
                                                                <img src={currentData?.image ? currentData?.image : file} style={{ width: 100, height: 'auto' }} />
                                                                :
                                                                <Cropper
                                                                    style={{ height: 'auto', width: 300 }}
                                                                    aspectRatio={'auto' / 'auto'}
                                                                    preview=".img-preview"
                                                                    guides={true}
                                                                    src={file}
                                                                    ref={cropper}
                                                                />
                                                            }
                                                            <i className="mdi mdi-close" style={{
                                                                color: 'white', backgroundColor: Utils.themeColor, fontSize: 20,
                                                                position: 'absolute', top: -16, left: 300, borderRadius: 15, width: 30, height: 30, textAlign: 'center'
                                                            }}
                                                                onClick={() => { changeImage() }}//setCurrentData({ ...currentData, image: undefined })
                                                            // onClick={() => { setFile(null); if (currentData) { } }}//setCurrentData({ ...currentData, banner: undefined })
                                                            // onClick={() => { setFile(null); setCurrentData({ ...currentData, image: null }); }}
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    <AvField
                                                        name="image"
                                                        label="Image*"
                                                        className="form-control"
                                                        type="file"
                                                        onChange={e => onChangeFile(e)}
                                                        multiple={false}
                                                        ref={imageInput}
                                                        accept="image/png, image/jpeg"
                                                    // value={currentData?.image}
                                                    />
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} md={6}>
                                            <div className="mb-3">
                                                <AvField
                                                    name="locationName"
                                                    label="Location Name*"
                                                    className="form-control"
                                                    placeholder="Enter location name"
                                                    type="text"
                                                    required
                                                    value={currentData?.locationName}
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={6} md={6}>
                                            <div className="mb-3">
                                                <AvField
                                                    name="personName"
                                                    label="Person Name"
                                                    className="form-control"
                                                    placeholder="Enter name"
                                                    type="text"
                                                    value={currentData?.personName}
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={6} md={6}>
                                            <div className="mb-3">
                                                <AvField
                                                    name="email"
                                                    label="Email"
                                                    className="form-control"
                                                    placeholder="Enter email name"
                                                    type="text"
                                                    value={currentData?.email}
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={6} md={6}>
                                            <div className="mb-3">
                                                <AvField
                                                    name="mobile"
                                                    label="Mobile No"
                                                    className="form-control"
                                                    placeholder="Enter mobile name"
                                                    type="text"
                                                    value={currentData?.mobile}
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={12} md={12}>
                                            <div className="mb-3">
                                                <AvField
                                                    name="address"
                                                    label="Address"
                                                    className="form-control"
                                                    placeholder="Enter address"
                                                    type="textarea"

                                                    value={currentData?.address}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <div className="mt-4">
                                        <Row>
                                            <Col md={6}>
                                                <button
                                                    className="btn btn-primary w-100 waves-effect waves-light"
                                                    style={{ backgroundColor: Utils.themeColor, border: 'none' }}
                                                    onClick={() => { setIsAddForm(false); setFile(null) }}
                                                    type="reset"
                                                >
                                                    Cancel
                                                </button>
                                            </Col>
                                            <Col md={6}>
                                                <button
                                                    className="btn btn-primary w-100 waves-effect waves-light"
                                                    type="submit"
                                                    style={{ backgroundColor: Utils.themeColor, border: 'none' }}
                                                >
                                                    {currentData?._id ? 'Update' : 'Add'}
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </AvForm>
                            </div>
                        </CardBody>
                    </Card>
                </Row>
            </div>
        </React.Fragment >
    )
}

export default Table;
